import * as core from '../../../../../../../core'
import * as changeImpactSprint from '../change-impact-sprint'

export const RESOURCE = {
  payload: {
    description: 'Sprint 12',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactSprint.RESOURCE.payload.partialId,
    }),
    id: 'Sprint 12',
    name: 'Sprint 12',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
